import { disableBodyScroll, enableBodyScroll } from './helpers/screenLock';

class Modal {
  constructor(modal) {
    this.modal = modal;

    this.modalElements = {
      element: this.modal,
      buttons: [...this.modal.querySelectorAll(`.${Modal.CLASSES.button}`)],
      modal: this.modal.querySelector(`.${Modal.CLASSES.modal}`)
    };
  }

  init() {
    this.attachEvents();
  }

  attachEvents() {
    document.addEventListener('keydown', (e) => {
      if (
        e.key !== "Escape" ||
        !this.modalElements.modal.classList.contains(Modal.CLASSES.active)
      ) return;

      this.hideModal();
      enableBodyScroll(this.modalElements.modal);
      this.isModalOpend = false;
    });

    this.modalElements.buttons.forEach(button => {
      button.addEventListener('click', () => this.toggleModal())
    });
  };

  toggleModal() {
    if(this.isModalOpend) {
      this.hideModal();
      enableBodyScroll(this.modalElements.modal);
    } else {
      this.showModal();
      disableBodyScroll(this.modalElements.modal);
    }

    this.isModalOpend = !this.isModalOpend;
  }

  showModal() {
    this.modalElements.modal.classList.add(Modal.CLASSES.active);
  }

  hideModal() {
    this.modalElements.modal.classList.remove(Modal.CLASSES.active);
  }
}

Modal.CLASSES = {
  modal: 'js-modal',
  button: 'js-modal-button',
  active: 'modal--active'
}

function modal() {
  const modals = [...document.querySelectorAll('.js-modal-container')];
  modals.forEach(modal => new Modal(modal).init());
};

export { modal };
